import { ApolloClient, gql } from "@apollo/client";
import { Toast } from "../../../../hooks/toast";
import { CreateApolloClient } from "../../../../lib/ApolloClient";

const SET_SHIPMENT = gql`
  mutation setStatusShipment($id: Int, $status: ProductShipStatus) {
    setStatusShipment(id: $id, status: $status)
  }
`;

const SET_SHIPMENT_REQUEST = gql`
  mutation merchantRequestPickupShipment($id: Int) {
    merchantRequestPickupShipment(id: $id)
  }
`;

export async function changeStatusShipment(id: number, status: "SHIPPED" | "DELETED" | "REQUEST") {
  const token = localStorage.getItem("token");
  const client: ApolloClient<any> = CreateApolloClient(token!);
  if (status === "REQUEST") {
    const { data } = await client.mutate({
      mutation: SET_SHIPMENT_REQUEST,
      variables: {
        id,
      },
      refetchQueries: ["merchantShipmentDetail"],
    });

    if (data.merchantRequestPickupShipment) {
      Toast.onShow("Shipment was repuest.", "success", "right");
      return true;
    }
  } else {
    const { data } = await client.mutate({
      mutation: SET_SHIPMENT,
      variables: {
        id,
        status,
      },
      refetchQueries: ["merchantShipmentDetail"],
    });

    if (data.setStatusShipment) {
      Toast.onShow("Shipment change status to " + status, "success", "right");
      return true;
    }
  }
}
